module.exports = __webpack_public_path__ + "static/BT_buried-05932be44a430ab468008ef9c1796e2f.png";